import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Pathologies.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import AddPathologyForm from "../components/AddPathologyForm";
import PathologyCard from "../components/PathologyCard";
import { Slide, toast, ToastContainer } from 'react-toastify';

const Pathologies = () => {
  const [pathologies, setPathologies] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isFormPopupOpen, setIsFormPopupOpen] = useState(false);
  const [isCardPopupOpen, setIsCardPopupOpen] = useState(false);
  const [selectedPathology, setSelectedPathology] = useState(null);

  const token =
    localStorage.getItem("token") || sessionStorage.getItem("token");

  useEffect(() => {
    const fetchPathologies = async () => {
      try {
        const response = await axios.get(
          "/pathologies",
          { 
            headers: {
              "x-access-token": token,
              Authorization: `Bearer ${localStorage.getItem("token") || sessionStorage.getItem("token")}`,
            }
          },
        );
        setPathologies(response.data);
      } catch (err) {
        setError("Error fetching pathologies");
      } finally {
        setLoading(false);
      }
    };

    fetchPathologies();
  }, [token, isFormPopupOpen, isCardPopupOpen]);

  const toggleFormPopup = () => {
    setIsFormPopupOpen(!isFormPopupOpen);
  };

  const toggleCardPopup = async (id) => {
    try {
      const response = await axios.get(`/pathologies/${id}`, {
        headers: {
          "x-access-token": token,
          Authorization: `Bearer ${localStorage.getItem("token") || sessionStorage.getItem("token")}`,
        },
      });
      setSelectedPathology(response.data);
      setIsCardPopupOpen(true);
    } catch (err) {
      setError("Error fetching pathology details");
    }
  };

  const closeCardPopup = () => {
    setIsCardPopupOpen(false);
    setSelectedPathology(null);
  };

  const handleDeleteSuccess = (pathologyName) => {
    toast.success(
      <span>
        La pathologie <b>{pathologyName}</b> a été supprimée avec succès !
      </span>,
      {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      transition: Slide,
    });
  };
  
  const handleDuplicateSuccess = (duplicatedPathology) => {
    toast.success(
      <span>
        La pathologie <b>{duplicatedPathology.pathologie}</b> a été dupliquée avec succès !
      </span>,
      {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'light',
        transition: Slide,
      }
    );
    setIsCardPopupOpen(false);
    setSelectedPathology(null);
  };

  if (loading) {
    return <div className="loading">Loading...</div>;
  }

  if (error) {
    return <div className="error">{error}</div>;
  }

  return (
    <div className="table-container">
      <div className="header">
        <h2 className="table-title">Table des pathologies</h2>
        <button className="add-button" onClick={toggleFormPopup}>
          <span className="ajouter-une-pathologie-text">
            Ajouter une pathologie
          </span>
          <FontAwesomeIcon icon={faPlus} />
        </button>
      </div>
      <table className="pathologies-table">
        <thead>
          <tr>
            <th>Pathologie</th>
            <th>Appareil</th>
          </tr>
        </thead>
        <tbody>
          {pathologies
            .filter((pathologie) => 
              pathologie.pathologie && 
              pathologie.appareilId && 
              pathologie.appareilId.appareil
            )
            .map((pathologie) => (
              <tr key={pathologie._id} onClick={() => toggleCardPopup(pathologie._id)}>
                <td>{pathologie.pathologie}</td>
                <td>{pathologie.appareilId.appareil}</td>
              </tr>
            ))}
        </tbody>
      </table>

      <PathologyCard
        isOpen={isCardPopupOpen}
        togglePopup={closeCardPopup}
        selectedPathology={selectedPathology}
        onDeleteSuccess={handleDeleteSuccess}
        onDuplicateSuccess={handleDuplicateSuccess}
      />
      <AddPathologyForm
        isOpen={isFormPopupOpen}
        togglePopup={toggleFormPopup}
      />
      <ToastContainer />
    </div>
  );
};

export default Pathologies;
